export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-11.jpg'),
        title: 'DATA ANALYTICS',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'DATA ACCELERATES PROFIT GROWTH AND IS THE PATH TO SUCCESS IN THE DIGITAL ECONOMY ERA',
      description: `<p style="font-size:1.5rem">Maesinfo uses advanced big data analysis technology to accelerate profit growth and succeed in the digital economy era.Due to asymmetric information (also known as information failure) the traditional business model is unable to grasp the precise user needs and loopholes in business operations, resulting in a lot of unnecessary losses.The advent of computers has enabled the computational analysis of large amounts of data. With the help of computers, through the collection and analysis of data from tens of millions of users, data is studied and summarized in detail, helping enterprises make more accurate judgments and more effective decisions. This helps enterprises record higher profit growth, spearheading them
to the top of the digital economy era.
</p>`
    },
    {
      title: 'OUR ADVANTAGE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-11.jpg')+`)"></span>
      <span>Maesinfo uses the most advanced big data analysis technology and also its rich experience in commercial services to collect relevant target data, analyze data, evaluate and improve the effectiveness of data analysis through market research. Thus MaesInfo will help you to more effectively judge market trends and develop appropriate production and sales plans, with precision and effectiveness in order to avoid blind decision-making and waste of resources. Get the most out of your business with the least cost.</span>`
    }
  ]
}
